<template>
	<div class="xingshi">
		<h4 class="xingshi-title">创建表格</h4>
		<div class="">
			<Form ref="wangge" :model="wangge" :rules="ruleWangge" action="javascript:void(0)">
				<FormItem label="行数" prop="rowNum">
					<Input type="number" v-model="wangge.rowNum" number placeholder="请输入行数" style="width:200px;"></Input>
				</FormItem>
				<FormItem label="列数" prop="colNum">
					<Input type="number" v-model="wangge.colNum" number placeholder="请输入列数" style="width:200px;"></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="toCreate('wangge')">创建</Button>
				</FormItem>
			</Form>
		</div>
		<div class="">
			<div class="actions-wrap">
				<Button type="success" @click="addRow">增加行</Button>
				<Button type="success" @click="addCol">增加列</Button>
				<Button type="error" @click="delRow">删除行</Button>
				<Button type="error" @click="delCol">删除列</Button>
				<Button type="primary" @click="saveTable">保存</Button>
			</div>
			<table class="xingshi-table" id="tableBox">
				<tr class="xingshi-tr" v-for="(trItem,trIndex) in dataList" :key="trIndex">
					<td v-for="(tdItem,tdIndex) in trItem" :key="tdIndex">{{ tdIndex }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			id: null,
			isCreate: false,
			dataList: [],
			ruleWangge: {
				rowNum: [
					{ type: 'number', required: true, message: '行数必须填写,且不得小于1',validator:(rule,value) => value>=1 }
				],
				colNum: [
					{ type: 'number', required: true, message: '列数必须填写,且不得小于1',validator:(rule,value) => value>=1  }
				]
			},
			wangge: {
				rowNum: null,
				colNum: null
			},
			initData: [],
		}
	},
	created(){
		this.id = this.$route.query.id;
	},
	methods: {
		/**
		 * @name: 删除列
		 * @return {*}
		 * @desc: 以3行3列为参考
		 */		
		delCol(){
			// 先按删除一列
			let tab = document.getElementById('tableBox');
			let rowLength = tab.rows.length; // 行数
			for(let i = 0; i < rowLength; i++){
				// tr.deleteCell(index)  -1是最后一个单元格将被删除 0是第一个单元格被删除
				tab.rows[i].deleteCell(-1)
			}
			// 同步 initData
			// 获取现有行
			let tabRows = tab.rows;
			// 获取现有列数
			let colums = tabRows[0].cells.length;
			// 每个单元格都是空的,不必须按位置删除
			for(let i = 0; i < colums; i ++){
				this.initData.pop();
			};
			console.log('删除列',this.initData);
		},
		/**
		 * @name: 增加列
		 * @return {*}
		 * @desc: 以3行3列为参考
		 */		
		addCol(){
			// 先按增加1列
			let tab = document.getElementById('tableBox');
			let rowLength = tab.rows.length; // 行数
			let columnLength = tab.rows[1].cells.length; // 现有列
			for(let i = 0; i < rowLength; i++){
				tab.rows[i].insertCell(columnLength)
			};
			// 同步 initData数据 (每个单元格都是空的,不必须按位置增加)
			for(let i = 0; i < rowLength; i ++){
				// i代表第几行
				let obj = {};
				this.initData.push(obj);
			};
			console.log('增加列',this.initData);
		},
		/**
		 * @name: 删除行
		 * @return {*}
		 * @desc: 
		 */		
		delRow(){
			// 先按删除1行
			let tab = document.getElementById('tableBox');
			let rowLength = tab.rows.length; // 行数
			tab.deleteRow(rowLength-1);
			// 同步 initData数据
			let tabRows = tab.rows;
			let colums = tabRows[0].cells.length;
			for(let i = 0; i < colums; i++){
				this.initData.pop();
			};
			console.log('删除行',this.initData)
		},
		/**
		 * @name: 增加行
		 * @return {*}
		 * @desc: 
		 */		
		addRow(){
			// 先按增加1行
			let tab = document.getElementById('tableBox');
			// 获取现有行
			let tabRows = tab.rows;
			console.log('增加行',tabRows.length)
			// 获取现有列数
			let colums = tabRows[0].cells.length;
			// 在现有行后面新增一行
			let newTr = tab.insertRow(tabRows.length);
			newTr.className = "xingshi-tr";
			// 在这一行，插入td
			console.log('有几列',colums);
			for(let i = 0 ; i < colums; i++){
				// 插入td
				newTr.insertCell(i);
			};
			// 同步 initData数据
			for(let i = 0; i < colums; i++){
				let obj = {};
				this.initData.push(obj);
			};
			console.log('增加行',this.initData)
		},
		saveTable(){
			// 得给个提醒
		},
		/**
		 * @name: 创建表格
		 * @param {*} name
		 * @return {*}
		 * @desc: 
		 */		
		toCreate(name){
			console.log('name==',this.wangge)
			this.$refs[name].validate((vaild)=>{
				if(vaild){
					this.isCreate = true;
					// this.createTable();
					this.initList();
				}
			})
		},
		/**
		 * @name: 创建表格
		 * @return {*}
		 * @desc: 
		 */		
		createTable(){
			let rowNum = this.wangge.rowNum;
			let colNum = this.wangge.colNum;
			//创建表格
			let tab = document.createElement('table');
			// 创建行
			for(let i = 0; i < rowNum; i++){
				let tr = tab.insertRow();
				// 创建单元格
				for(let j = 0; j < colNum; j++){
					tr.insertCell();
				}
			};
			// 放到dom中
			document.body.appendChild(tab);
		},
		/**
		 * @name: 初始化table
		 * @return {*}
		 * @desc: 
		 */		
		initList(){
			let rowNum = this.wangge.rowNum;
			let colNum = this.wangge.colNum;
			let total = rowNum * colNum;
			let list = [];
			for(let i = 0; i < total; i++){
				list.push({})
			};
			this.initData = list;
			this.zuheData(colNum);
		},
		/**
		 * @name: 组合数据
		 * @param {*} colNum
		 * @return {*}
		 * @desc:  例如3行4列   colNum为4列
		 */			
		zuheData(colNum){
			let initData = this.initData;
			let dataList = [];
			for(let i = 0; i < this.initData.length; i+=colNum){
				dataList.push(initData.slice(i,i+colNum))
			};
			this.dataList = dataList;
		}
	}
}
</script>